import { LAYER_SETTINGS_TYPES } from '../../constants';
import { WellsStateSvg } from '../icons';
import type { LayerPattern } from '..';
import { WellsStateLegendItem } from './WellsStateLegendItem';

export const wellsState: LayerPattern = {
    id: 'WellsState',
    key: 'well_state',
    title: 'Состояния скважин',
    icon: WellsStateSvg,
    settings: [
        {
            title: 'Размер (коэф.)',
            key: 'scaleFactor',
            type: LAYER_SETTINGS_TYPES.FLOAT,
            defaultValue: 1.0,
            level: 0,
        },
        {
            title: 'Легенда',
            key: 'Легенда',
            type: LAYER_SETTINGS_TYPES.CUSTOM,
            widget: WellsStateLegendItem,
            defaultValue: null,
            level: 0,
        },
    ],
};
